import { ReportPageProvider } from '../context/useReportPageContext'
import { AllUserReportsProvider, useAllUserReportsContext } from '../context/useAllUserReportsContext'
import ReportPageGraphsContainer from './ReportPageGraphsContainer'
import ReportPageHeader from './ReportPageHeader'

const ReportsContainer = () => {
    return (
        <AllUserReportsProvider>
            <ReportPage />
        </AllUserReportsProvider>
    )
}

const ReportPage = () => {
    const { reportsUuid } = useAllUserReportsContext()
    return (
        <ReportPageProvider uuid={reportsUuid[0]}>
            <ReportPageHeader/>
            <ReportPageGraphsContainer/>
        </ReportPageProvider>
    )
}
   
export default ReportsContainer